<div id="race-ev-desc" *ngIf="!!eventDescription">
    <p>{{eventDescription}}</p>
</div>